import { h, Component } from "preact";
import { Text, Localizer } from "preact-i18n";

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      success: null,
      error: null
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    console.log("e.target");
    console.log(e.target);
    console.log(e.target.langs.value);
    let request = {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        name: e.target.name.value,
        email: e.target.email.value,
        phone: e.target.phone.value,
        lang: e.target.langs.value,
        //subject: e.target.subject.value,
        message: e.target.message.value,
        languageCode: this.props.lang
      })
    };

    return fetch(
      /* 
  TODO: .env no working
  process.env.REACT_APP_API_URL + "/0/usermessage" */
      "https://api.agroinsider360.com/agroinsider/api/agromap/0/academyapply", request)
      //"http://localhost:4000/agromap/0/academyapply/", request)
      .then(r =>
        this.setState({
          success: "Email was sent! We'll get back to you as soon as possible."
        })
      )
      .catch(e =>
        this.setState({
          error:
            "An unknown error has ocurred, please try again at a later time."
        })
      );
  };

  renderMessage = () => {
    if (this.state.success) {
      return (
        <div class="uk-alert-success" uk-alert>
          <a class="uk-alert-close" uk-close />
          <p>
            <Text id="Contact.success">{this.state.success}</Text>
          </p>
        </div>
      );
    } else if (!this.state.success && this.state.error) {
      return (
        <div class="uk-alert-danger" uk-alert>
          <a class="uk-alert-close" uk-close />
          <p>
            <Text id="Contact.error">{this.state.error}</Text>
          </p>
        </div>
      );
    }
  };
          
  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <fieldset class="uk-fieldset">
          <legend class="uk-legend">
            <Text id="Contact.title">Contact Form</Text>
          </legend>

          <div class="uk-margin">
            <div class="uk-inline">
              <i class="uk-form-icon" href="#" uk-icon="icon: pencil" />
              <Localizer>
                <input
                  id="name"
                  class="uk-input"
                  type="text"
                  placeholder={<Text id="Contact.name">Your Name</Text>}
                  ref={node => (this.inputNode = node)}
                />
              </Localizer>
            </div>
          </div>

          <div class="uk-margin">
            <div class="uk-inline">
              <i class="uk-form-icon" href="#" uk-icon="icon: mail" />
              <Localizer>
                <input
                  id="email"
                  class="uk-input"
                  type="text"
                  placeholder={<Text id="Contact.email">Your email</Text>}
                  required
                  ref={node => (this.inputNode = node)}
                />
              </Localizer>
            </div>
          </div>

          <div class="uk-margin">
            <div class="uk-inline">
              <i class="uk-form-icon" href="#" uk-icon="icon: list" />
              <Localizer>
                <select  
                  id="langs"
                  class="uk-input"
                  type="text"
                  required
                  >
                  <option value="" disabled selected>{<Text id="Contact.lang">Select your language</Text>}</option>
                  <option value="portugues">Português</option>
                  <option value="espanhol">Espanhol</option>
                  <option value="ingles">Inglês</option>
                </select>
              </Localizer>
            </div>
          </div>

          <div class="uk-margin">
            <div class="uk-inline">
              <i class="uk-form-icon" href="#" uk-icon="icon: phone" />
              <Localizer>
                <input
                  id="phone"
                  class="uk-input"
                  type="text"
                  required
                  placeholder={
                    <Text id="Contact.phone">Your phone number</Text>
                  }
                  ref={node => (this.inputNode = node)}
                />
              </Localizer>
            </div>
          </div>

          <div class="uk-margin">
            <div class="uk-inline">
              <i class="uk-form-icon" href="#" uk-icon="icon: file-edit" />
              <Localizer>
                <textarea
                  id="message"
                  class="uk-textarea"
                  rows="5"
                  placeholder={<Text id="Contact.message">Your message</Text>}
                  //required
                  ref={node => (this.inputNode = node)}
                />
              </Localizer>
            </div>
          </div>
        </fieldset>
        <button
          class="uk-button uk-button-primary uk-width-1-1 uk-margin-small-bottom"
          disabled={this.state.success ? true : false}
        >
          <Text id="Contact.send">Send</Text>
        </button>
        {this.renderMessage()}
      </form>
    );
  }
}

class Contact extends Component {
  render() {
    return (
      <div id={this.props.id}>
        <div class="uk-container">
          <hr />
        </div>
        <div class="uk-section uk-section-default uk-section-large">
          <div class="uk-container">
            <div class="uk-width-xlarge uk-margin-auto uk-text-center uk-margin-large-bottom">
              <h2 class="uk-h1 uk-margin-top">
                <Text id="Contact.talkToUs">Talk to us</Text>
              </h2>
            </div>
            <div />
            <ContactForm lang={this.props.lang} />
          </div>
           
        </div>
        
      </div>
    );
  }
}

export default Contact;